import { useLocation } from 'react-router-dom';

import { PasswordRecoveryWizard } from '@identity/presentation/components/specific';

type PasswordRecoveryLocationState = { email?: string };

/**
 * The route where the recovery request is made. It is the first screen of the domain with no
 * authorizer at all, and that is the point: it exists for whoever cannot authenticate.
 */
export const PasswordRecoveryPage = () => {
  const { state } = useLocation<PasswordRecoveryLocationState | undefined>();

  return <PasswordRecoveryWizard initialEmail={state?.email ?? ''} />;
};
